/* @flow */
import { Container } from 'flux/utils';

import React from 'react';
import CurrentUser from 'auth/CurrentUser';
import GroupActions from '../../groups/actions/GroupActions';
import GroupStore from '../../groups/stores/GroupStore';
import ArchivedClassesList from './ArchivedClassesList.jsx';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator.jsx';
import Fieldset from 'components/Fieldset.jsx';
import Legend from 'components/Legend.jsx';

class ArchivedClassesView extends React.Component {
  static getStores() {
    return [GroupStore, CurrentUser];
  }

  static calculateState() {
    const archivedClasses = GroupStore.getArchivedGroups();
    const loaded = GroupStore.isArchivedLoaded();
    const canCreateGroups = CurrentUser.getUser().canCreateGroups();

    return {
      archivedClasses,
      loaded,
      canCreateGroups,
    };
  }

  state = {};

  componentDidMount() {
    if (!GroupStore.isArchivedLoaded()) {
      GroupActions.loadArchivedGroups();
    }
  }

  renderList() {
    return (
      <ArchivedClassesList
        archivedClasses={this.state.archivedClasses}
        canCreateGroups={this.state.canCreateGroups}
      />
    );
  }

  renderLoadingIndicator() {
    return <CenteredLoadingIndicator />;
  }

  render() {
    return (
      <div>
        <Fieldset>
          <Legend>
            Archived Classes
            <p>
              Restore or reuse classes you’ve archived.
            </p>
          </Legend>
          {this.state.loaded ? this.renderList() : this.renderLoadingIndicator()}
        </Fieldset>
      </div>
    );
  }
}

export default Container.create(ArchivedClassesView, { pure: false });



// WEBPACK FOOTER //
// ./src/settings/components/ArchivedClassesView.jsx